import { render, staticRenderFns } from "./SiestaFooter.vue?vue&type=template&id=6085d93a&scoped=true&"
import script from "./SiestaFooter.vue?vue&type=script&lang=js&"
export * from "./SiestaFooter.vue?vue&type=script&lang=js&"
import style0 from "./SiestaFooter.vue?vue&type=style&index=0&id=6085d93a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6085d93a",
  null
  
)

export default component.exports